var exports = {
  "kL": "x31de4314--c84df4--container",
  "Ox": "x31de4314--c84df4--container-m",
  "HV": "x31de4314--c84df4--container-l",
};

module.exports = exports;
